module.exports = __webpack_public_path__ + "static/media/news-2.d1dc3b28.svg";